<div class="breadcrumb flex">
  <p-breadcrumb class="max-w-full" [model]="breadcrumb"></p-breadcrumb>
</div>
<div class="company-block-wrap">
  <div class="white-ui-block mt-0">
    <div class="company-header flex">
      <div class="avatar-block">
        <p-image
          *ngIf="companyData?.avatar_img_url.length > 0"
          [src]="'/proxy/cards-base.marketplace/api/files/by-fullpath?fullPath='+companyData?.avatar_img_url"
          alt="Image"
          [preview]="true"
          width="250">
          <ng-template pTemplate="indicator">
          </ng-template>
        </p-image>
        <img *ngIf="companyData?.avatar_img_url.length == 0"
             src="assets/images/main/company-filler-avatar.svg" alt="">
      </div>
      <div class="company-header-info">
        <div class="company-name">
          {{
            companyData?.trade_name_ru?.trim()
              ? (translate.currentLang == 'ru' ? companyData.trade_name_ru : companyData.trade_name_kz)
              : (translate.currentLang == 'ru' ? companyData?.name_ru : companyData?.name_kz)
          }}
        </div>
        <div class="company-bin cursor-pointer" (click)="copyBin()">
          {{ 'IINBIN' | translate }}: {{ companyData?.bin }}

          <svg *ngIf="!copied" class="copy-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M5 2H9.73333C11.2268 2 11.9735 2 12.544 2.29065C13.0457 2.54631 13.4537 2.95426 13.7094 3.45603C14 4.02646 14 4.77319 14 6.26667V11M4.13333 14H9.53333C10.2801 14 10.6534 14 10.9387 13.8547C11.1895 13.7268 11.3935 13.5229 11.5213 13.272C11.6667 12.9868 11.6667 12.6134 11.6667 11.8667V6.46667C11.6667 5.71993 11.6667 5.34656 11.5213 5.06135C11.3935 4.81046 11.1895 4.60649 10.9387 4.47866C10.6534 4.33333 10.2801 4.33333 9.53333 4.33333H4.13333C3.3866 4.33333 3.01323 4.33333 2.72801 4.47866C2.47713 4.60649 2.27316 4.81046 2.14532 5.06135C2 5.34656 2 5.71993 2 6.46667V11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27316 13.5229 2.47713 13.7268 2.72801 13.8547C3.01323 14 3.3866 14 4.13333 14Z"
                  stroke="#8D959D" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <svg *ngIf="copied" class="chevron" width="16" height="16" viewBox="0 0 16 16" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_10961_23561)">
              <path
                d="M5.49987 11.5195L2.6082 8.62786C2.2832 8.30286 1.7582 8.30286 1.4332 8.62786C1.1082 8.95286 1.1082 9.47786 1.4332 9.80286L4.91654 13.2862C5.24154 13.6112 5.76654 13.6112 6.09154 13.2862L14.9082 4.46953C15.2332 4.14453 15.2332 3.61953 14.9082 3.29453C14.5832 2.96953 14.0582 2.96953 13.7332 3.29453L5.49987 11.5195Z"
                fill="#05A660" />
            </g>
            <defs>
              <clipPath id="clip0_10961_23561">
                <rect width="20" height="20" fill="white" transform="translate(-2 -1.95508)" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div *ngIf="totalRatingsNumber > 0" class="company-rating w-fit cursor-pointer" (click)="scrollToReviews()">
          <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.4513 12.963C9.98879 13.3089 7.0212 11.1163 6.45284 11.1115C5.88448 11.1067 2.88349 13.2488 2.42639 12.8952C1.96928 12.5415 3.04391 8.9091 2.87265 8.34171C2.7014 7.77432 -0.171872 5.44806 0.00811114 4.88363C0.188134 4.31919 3.81987 4.26676 4.28237 3.92088C4.74487 3.57503 5.97011 -0.00477262 6.53851 4.77737e-06C7.10683 0.00482372 8.27672 3.60486 8.73382 3.95851C9.19093 4.31213 12.8214 4.42595 12.9927 4.99334C13.164 5.56073 10.2553 7.83813 10.0753 8.40257C9.89527 8.96701 10.9138 12.6171 10.4513 12.963Z" fill="#FFCE31"/>
          </svg>

          {{ allRatings?.average_grade }}<span class="review-count">{{ totalRatingsNumber | suffix: ('OneReview' | translate): ('SomeReviews' | translate): ('ManyReviews' | translate)}} </span>
        </div>
        <div class="">
          <div class="flex tag-list">
            <ng-container *ngIf="!showAllTags; else allTags">
              <div *ngFor="let item of companyData?.tags.slice(0, 3)" class="company-tag">
                {{ item.name_ru }}
              </div>
              <div *ngIf="companyData?.tags.length > 3" class="company-tag" (click)="showAllTags = true">
                <span>+{{ companyData?.tags.length - 3 }}</span>
              </div>
            </ng-container>
            <ng-template #allTags>
              <div *ngFor="let item of companyData?.tags" class="company-tag">
                {{ item.name_ru }}
              </div>
              <div (click)="showAllTags = false" class="company-tag">
                {{ 'Свернуть' | translate }}
              </div>
            </ng-template>
          </div>
        </div>
        <div *ngIf="companyData?.social_networks.length > 0" class="social-list">
          <a *ngFor="let item of companyData?.social_networks" [href]="item" target="_blank">
            <img [src]="getSocialIcon(item)" alt="Social Icon">
          </a>
        </div>
      </div>
      <div class="company-btn-group ml-auto">
        <div class="secondary-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.7914 12.6082C21.0355 12.3989 21.1575 12.2943 21.2023 12.1698C21.2415 12.0605 21.2415 11.941 21.2023 11.8317C21.1575 11.7072 21.0355 11.6026 20.7914 11.3934L12.3206 4.13275C11.9004 3.77256 11.6903 3.59246 11.5124 3.58804C11.3578 3.58421 11.2101 3.65213 11.1124 3.77201C11 3.90995 11 4.18668 11 4.74016V9.03541C8.86532 9.40887 6.91159 10.4905 5.45971 12.1146C3.87682 13.8853 3.00123 16.1767 3 18.5517V19.1637C4.04934 17.8996 5.35951 16.8773 6.84076 16.1667C8.1467 15.5402 9.55842 15.1691 11 15.0713V19.2614C11 19.8149 11 20.0916 11.1124 20.2296C11.2101 20.3494 11.3578 20.4174 11.5124 20.4135C11.6903 20.4091 11.9004 20.229 12.3206 19.8688L20.7914 12.6082Z" stroke="#8D959D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          Поделиться
        </div>
        <div class="secondary-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3036 4.67974C20.2179 3.60425 18.7452 3 17.2095 3C15.6738 3 14.201 3.60425 13.1153 4.67974L11.9997 5.7844L10.8841 4.67974C8.62297 2.44083 4.95697 2.44083 2.69584 4.67974C0.434719 6.91865 0.434719 10.5486 2.69584 12.7875L3.81147 13.8922L11.9997 22L20.188 13.8922L21.3036 12.7875C22.3898 11.7126 23 10.2543 23 8.73364C23 7.21302 22.3898 5.75472 21.3036 4.67974Z" stroke="#8D959D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          В контрагенты
        </div>
<!--        <div class="secondary-btn">-->

<!--          Это моя компания-->
<!--        </div>-->
      </div>
    </div>

  </div>
  <div class="white-ui-block">
    <div class="block-header">
      О компании
    </div>
    <div class=""
         [innerHTML]="getSafeDescriptionPreview(translate.currentLang == 'ru' ? companyData?.description_ru : companyData?.description_kz)">

    </div>
  </div>
  <div class="white-ui-block">
    <div class="header-wrap">
      <div class="block-header">
        Товары и услуги
      </div>
      <div *ngIf="cardList?.list?.content?.length != 0" class="goods-count">
        Показать все {{ cardList?.list?.totalElements }}
      </div>
    </div>
    <div class="flex">
      <div class="goods-empty-wrap" *ngIf="cardList?.list?.content?.length == 0">
        <div class="goods-empty-header">
          Пока пусто!
        </div>
        <div class="goods-empty-description">
          Похоже, компания еще не успела добавить товары или услуги. Загляните позже!
        </div>
      </div>
      <div class="cards-wrap" *ngIf="cardList?.list?.content?.length != 0">
        <app-card-template *ngFor="let item of cardList?.list?.content; index as i" [cardInfo]="item" [cardIndex]="i" [isAuth]="isAuth"></app-card-template>
      </div>
    </div>
  </div>
  <div class="white-ui-block">
    <div class="block-header">
      Контакты
    </div>
    <div class="flex gap-5 mb-5" *ngFor="let item of companyData?.filials; let i = index">
      <div class="contact-data" [class.hidden]="!showAllBranches && i > 0">
        <div class="flex mb-3">
          <div class="w-7rem data-name">
            Адрес
          </div>
          <div class="">
            {{ item?.address }}
          </div>
        </div>
        <div class="flex mb-3">
          <div class="w-7rem data-name">
            Почта
          </div>
          <div class="flex flex-column">
            <div class="" *ngFor="let email of item?.email">
              {{ email }}
            </div>
          </div>
        </div>
        <div class="flex mb-3">
          <div class="w-7rem data-name">
            Телефон
          </div>
          <div class="flex flex-column">
            <div class="" *ngFor="let phone	of item?.phone">
              {{ phone }}
            </div>
          </div>
        </div>
        <div *ngIf="item?.whatsapp?.length > 0" class="flex mb-3">
          <div class="w-7rem data-name">
            WhatsApp
          </div>
          <div class="flex flex-column">
            <div class="" *ngFor="let whatsapp	of item?.whatsapp">
              {{ whatsapp }}
            </div>
          </div>
        </div>
        <div *ngIf="item?.telegram?.length > 0" class="flex mb-3">
          <div class="w-7rem data-name">
            Telegram
          </div>
          <div class="flex flex-column">
            <div class="" *ngFor="let telegram of item?.telegram">
              {{ telegram }}
            </div>
          </div>
        </div>
        <div class="flex mb-3">
          <div class="w-7rem data-name">
            Сайт
          </div>
          <div class="flex flex-column">
            <div class="" *ngFor="let website	of item?.website">
              <a target="_blank" [href]="website.startsWith('https') ? website : 'https://' + website">
                {{ website }}
              </a>
            </div>
          </div>
        </div>
        <div class="flex mb-3">
          <div class="w-7rem data-name">
            Время работы
          </div>
          <div class="">
            {{ item?.working_time }}
          </div>
        </div>
      </div>
      <div class="map" [class.hidden]="!showAllBranches && i > 0">
        <div [id]="'map' + item.id" style="width: 100%; height: 100%;">

        </div>
      </div>
    </div>

    <div class="additional" (click)="showAllBranches = true"
         *ngIf="!showAllBranches && companyData?.filials?.length > 1">
      Посмотреть другие филиалы
    </div>
    <div class="additional" (click)="showAllBranches = false" *ngIf="showAllBranches">
      Свернуть
    </div>
  </div>
  <div class="white-ui-block">
    <div class="header-wrap" #reviewsSection>
      <div class="block-header">
        Отзывы
      </div>
    </div>
    <div class="review-block" *ngIf="haveFeedbacks">
      <div class="review-list">
        <div *ngFor="let item of feedbackList?.feedbacks" class="review-item mb-5">
          <div class="">
            <app-rating [rating]="item?.grade" [height]="'16px'" [width]="'16px'"></app-rating>
          </div>
          <div class="user-name">
            <span>{{ item.isAnonymous ? 'Анонимный пользователь' : item.userId }}</span>
            <span class="feedback-date">{{ ' '+item.createDate }}</span>
          </div>
          <div class="">
            {{ item.review }}
          </div>
          <div class="review-item-images">
            <img *ngFor="let image of item?.images" [style.width]="calcImageWidth(item?.images.length)"
                 [src]="'/proxy/cards-base.marketplace/api/files/by-fullpath?fullPath='+image?.full_path"
                 alt="">
          </div>


          <p-inplace *ngIf="!item?.feedbackComment?.comment && bin.bin == headerService?._userData?.userInfo?.mainCompanyBin &&
                            item?.feedbackComment == null">
              <ng-template pTemplate="display">
                <div class="company-comment">
                  Ответить
                </div>
              </ng-template>
              <ng-template pTemplate="content">
                <div class="">
                  <textarea [ngClass]="{'textarea-err' : answerErr}" [(ngModel)]="item.feedbackComment" class="review-description" placeholder="Введите комментарий"></textarea>
                  <div *ngIf="answerErr" class="textarea-err-description">
                    Поле ответа не заполненно
                  </div>
                  <div class="blue-btn-8-20 mt-2 ml-auto" (click)="sendCompanyComment(item?.feedbackComment, item.id)">
                    Ответить
                  </div>
                </div>
              </ng-template>
          </p-inplace>
          <div class="company-answer" *ngIf="item?.feedbackComment?.comment &&
                            item?.feedbackComment?.comment.length > 0">
            <div class="company-answer-header">
              Ответ от компании
            </div>
            {{ item.feedbackComment.comment }}
          </div>


        </div>
      </div>
      <div class="rating-block">


        <div class="flex justify-content-between mb-4">
          <app-rating [rating]="allRatings?.average_grade" [height]="'20px'" [floating]="true"></app-rating>

          <div class="average-rating">
            {{ allRatings?.average_grade | json }}
          </div>
        </div>


        <div class="flex rating-list-wrap">
          <div class="rating-list">
            <div class="rating-item">
              <div class="rating-item-txt">5 звёзд</div>
              <p-progressBar [value]="calculatePercentage(ratingCharts.five,totalRatingsNumber)" [showValue]="false" [color]="'#FFCE31'"></p-progressBar>
            </div>
            <div class="rating-item">
              <div class="rating-item-txt">4 звезды</div>
              <p-progressBar [value]="calculatePercentage(ratingCharts.four,totalRatingsNumber)" [showValue]="false" [color]="'#FFCE31'"></p-progressBar>
            </div>
            <div class="rating-item">
              <div class="rating-item-txt">3 звезды</div>
              <p-progressBar [value]="calculatePercentage(ratingCharts.three,totalRatingsNumber)" [showValue]="false" [color]="'#FFCE31'"></p-progressBar>
            </div>
            <div class="rating-item">
              <div class="rating-item-txt">2 звезды</div>
              <p-progressBar [value]="calculatePercentage(ratingCharts.two,totalRatingsNumber)" [showValue]="false" [color]="'#FFCE31'"></p-progressBar>
            </div>
            <div class="rating-item">
              <div class="rating-item-txt">1 звезда</div>
              <p-progressBar [value]="calculatePercentage(ratingCharts.one,totalRatingsNumber)" [showValue]="false" [color]="'#FFCE31'"></p-progressBar>
            </div>
          </div>
          <div class="">
            <div class="rating-item-txt mb-2">
              {{ ratingCharts.five }}
            </div>
            <div class="rating-item-txt mb-2">
              {{ ratingCharts.four }}
            </div>
            <div class="rating-item-txt mb-2">
              {{ ratingCharts.three }}
            </div>
            <div class="rating-item-txt mb-2">
              {{ ratingCharts.two }}
            </div>
            <div class="rating-item-txt mb-2">
              {{ ratingCharts.one }}
            </div>
          </div>
        </div>

        <div class="rating-item-txt mt-4 mb-5">
          Средний рейтинг формируется на основе всех оставленных отзывов
        </div>

        <div *ngIf="bin.bin != headerService?._userData?.userInfo?.mainCompanyBin"
             class="blue-btn-8-20 w-full text-center" (click)="openReviewModal()">
          Оставить отзыв
        </div>

      </div>
    </div>
    <div class="empty-feed mx-auto" *ngIf="!haveFeedbacks">
      <div class="empty-feed-header">
        Пока пусто!
      </div>
      <div class="empty-feed-description">
        Мы уверены, что скоро появятся отзывы от довольных покупателей
      </div>
      <div *ngIf="bin.bin != headerService?._userData?.userInfo?.mainCompanyBin"
           class="white-btn-8-20 w-fit text-center px-4" (click)="openReviewModal()">
        Оставить отзыв
      </div>
    </div>

  </div>
  <div class="white-ui-block">
    <div class="block-header">
      Оплата
    </div>
    <div class="flex gap-2 flex-wrap">
      <div class="company-tag cursor-auto" *ngFor="let item of companyData?.payment">
        {{ translate.currentLang == 'ru' ? item.name_ru : item.name_kz }}
      </div>
    </div>
  </div>

  <div class="white-ui-block">
    <div class="block-header">
      Доставка
    </div>
    <div class="flex gap-2 flex-wrap">
      <div class="company-tag cursor-auto" *ngFor="let item of companyData?.delivery">
        {{ translate.currentLang == 'ru' ? item.name_ru : item.name_kz }}
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="reviewModal" [modal]="true" [draggable]="false" [resizable]="false">
  <div class="modal-header mb-4">
    Оставить отзыв
  </div>
  <div class="company-badge">
    <img *ngIf="companyData?.avatar_img_url.length > 0"
         [src]="'/proxy/cards-base.marketplace/api/files/by-fullpath?fullPath='+companyData?.avatar_img_url" alt="">
    <img *ngIf="companyData?.avatar_img_url.length == 0"
         src="assets/images/main/company-filler-avatar.svg" alt="">
    <div class="">
      <div class="company-badge-name">
        {{ (translate.currentLang == 'ru' ? companyData?.name_ru : companyData?.name_kz) | shortname }}
      </div>
      <div class="company-bin">
        {{ 'IINBIN' | translate }}: {{ companyData?.bin }}
      </div>
    </div>
  </div>
  <div class="my-3 text-center">
    <p-rating [(ngModel)]="starRating" (ngModelChange)="starErr = false" [ngModelOptions]="{standalone: true}" [stars]="5" [readonly]="false">
      <ng-template class="star-fill" pTemplate="onicon">
        <svg width="42" height="42" class="cursor-pointer" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="star (1) 1">
            <path id="Vector" d="M9.8434 11.9687C9.45205 12.2614 6.94102 10.4061 6.4601 10.4021C5.97918 10.398 3.43987 12.2106 3.0531 11.9113C2.66632 11.6121 3.57561 8.53847 3.43071 8.05837C3.2858 7.57827 0.854569 5.6099 1.00686 5.1323C1.15919 4.6547 4.2322 4.61034 4.62354 4.31767C5.01489 4.02503 6.05163 0.995962 6.53259 1C7.01347 1.00408 8.00338 4.05027 8.39016 4.34951C8.77694 4.64872 11.8489 4.74504 11.9938 5.22513C12.1388 5.70523 9.67754 7.63227 9.52521 8.10987C9.37292 8.58747 10.2347 11.676 9.8434 11.9687Z" fill="#FFCE31"/>
          </g>
        </svg>
      </ng-template>
      <ng-template pTemplate="officon">
        <svg *ngIf="starErr" class="cursor-pointer" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_11263_38596)">
            <path d="M27.911 13.1845L27.911 13.1845C28.184 13.3957 28.6197 13.5463 29.0812 13.6688C29.5662 13.7976 30.1651 13.9158 30.8283 14.0285C31.7404 14.1836 32.8019 14.3329 33.8912 14.486C34.3825 14.5551 34.8795 14.6249 35.371 14.6965C36.9649 14.9285 38.5045 15.1788 39.6757 15.4814C40.2633 15.6331 40.7335 15.792 41.0639 15.9567C41.2286 16.0388 41.3422 16.1144 41.4149 16.179C41.4882 16.2441 41.4984 16.2787 41.4978 16.2768C41.4982 16.2784 41.5078 16.3176 41.483 16.4173C41.458 16.518 41.4049 16.6515 41.3142 16.8197C41.1323 17.1568 40.8327 17.5721 40.4346 18.0504C39.6408 19.0042 38.517 20.1365 37.34 21.2853C36.9768 21.6398 36.6083 21.9961 36.244 22.3483C35.4368 23.1288 34.6504 23.8891 33.9894 24.5645C33.5088 25.0556 33.0844 25.5118 32.7591 25.9078C32.4485 26.286 32.1793 26.666 32.0745 26.9948L32.0744 26.9949C31.97 27.3223 31.9671 27.7925 31.9983 28.289C32.031 28.8089 32.1084 29.4395 32.2108 30.134C32.3516 31.0892 32.5439 32.1909 32.7413 33.3223C32.8304 33.8331 32.9206 34.3499 33.0076 34.8621C33.2893 36.5208 33.5383 38.1343 33.6257 39.3978C33.6695 40.0315 33.6708 40.5536 33.6225 40.9393C33.5984 41.1319 33.5641 41.2723 33.5264 41.3683C33.4965 41.4445 33.4723 41.4731 33.4664 41.4795C33.4589 41.483 33.4298 41.4944 33.3635 41.4986C33.2716 41.5043 33.1394 41.4937 32.9608 41.4558C32.6029 41.3798 32.1359 41.2112 31.5787 40.9628C30.4683 40.4677 29.0934 39.6992 27.686 38.8821C27.2519 38.6301 26.8144 38.3732 26.3818 38.1194C25.4233 37.5567 24.4894 37.0085 23.6715 36.5589C23.0768 36.2321 22.5305 35.95 22.0692 35.7481C21.6315 35.5565 21.1953 35.4017 20.8519 35.3988C20.5084 35.3959 20.0697 35.5433 19.6292 35.7275C19.1648 35.9217 18.6142 36.1944 18.0145 36.5112C17.1897 36.947 16.2474 37.4793 15.2803 38.0257C14.844 38.2723 14.4026 38.5216 13.9647 38.7662C12.5448 39.5594 11.1583 40.3047 10.0405 40.7808C9.47956 41.0198 9.01013 41.1805 8.65115 41.2504C8.47204 41.2853 8.33966 41.2936 8.24783 41.2864C8.18114 41.2811 8.15228 41.269 8.14489 41.2654C8.13914 41.259 8.11519 41.23 8.08627 41.1528C8.05009 41.0561 8.01789 40.915 7.99677 40.722C7.95448 40.3356 7.96379 39.8136 8.01737 39.1807C8.1242 37.9188 8.398 36.3098 8.70526 34.6561C8.80014 34.1454 8.89828 33.6301 8.99528 33.1208C9.21011 31.9929 9.41928 30.8947 9.57481 29.942C9.68789 29.2493 9.77495 28.6201 9.81568 28.1008C9.85457 27.6049 9.85886 27.1347 9.75955 26.8057C9.65981 26.4752 9.39667 26.0908 9.09192 25.7075C8.77286 25.3061 8.35555 24.8428 7.88257 24.3437C7.23206 23.6572 6.45752 22.8837 5.6624 22.0897C5.30362 21.7314 4.94064 21.3689 4.58298 21.0083C3.42382 19.8397 2.31756 18.6886 1.53852 17.7214C1.14785 17.2364 0.854664 16.8161 0.677934 16.4758C0.589757 16.3061 0.538763 16.1717 0.515252 16.0705C0.492122 15.971 0.502033 15.9318 0.502555 15.9298C0.503108 15.9284 0.516215 15.8944 0.586719 15.8338C0.66028 15.7706 0.774936 15.6969 0.940876 15.6176C1.27371 15.4585 1.74624 15.3076 2.33602 15.1658C3.51171 14.8831 5.05492 14.6589 6.65223 14.4538C7.14462 14.3906 7.64253 14.3291 8.13481 14.2684C9.22635 14.1337 10.2902 14.0024 11.2046 13.8627C11.8694 13.7612 12.4701 13.6531 12.957 13.5325C13.4203 13.4178 13.8584 13.2745 14.1348 13.0679C14.409 12.8628 14.6778 12.4794 14.9306 12.0597C15.1963 11.6183 15.488 11.0601 15.7951 10.4351C16.2176 9.57557 16.6806 8.56581 17.1561 7.5289C17.3708 7.06084 17.588 6.58725 17.8051 6.11945C18.5085 4.60402 19.2126 3.14608 19.8509 2.07089C20.1711 1.5314 20.4623 1.10985 20.716 0.829606C20.8427 0.689613 20.9471 0.599517 21.0277 0.547441C21.0793 0.514082 21.1092 0.503957 21.1202 0.501012C21.1311 0.504142 21.161 0.514784 21.2122 0.549107C21.2921 0.602603 21.3952 0.694524 21.5197 0.836682C21.7691 1.12126 22.0538 1.54774 22.3656 2.09258C22.9872 3.17847 23.6688 4.64815 24.3487 6.17527C24.5585 6.64663 24.7684 7.12378 24.9757 7.59535C25.4352 8.64022 25.8827 9.65773 26.2918 10.5244C26.5892 11.1544 26.8723 11.7175 27.1312 12.1633C27.3775 12.5873 27.6402 12.975 27.911 13.1845Z" fill="#F6F7F8" stroke="#B30320"/>
          </g>
          <defs>
            <clipPath id="clip0_11263_38596">
              <rect width="42" height="42" fill="white"/>
            </clipPath>
          </defs>
        </svg>

        <svg *ngIf="!starErr" class="cursor-pointer" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_11263_36665)">
            <path d="M33.7657 41.8804C32.2715 42.9979 22.6839 35.9143 20.8476 35.8988C19.0114 35.8833 9.31588 42.804 7.83909 41.6614C6.3623 40.5188 9.83416 28.7833 9.28088 26.9501C8.72759 25.117 -0.55528 17.6014 0.0262052 15.7779C0.607819 13.9543 12.3411 13.7849 13.8353 12.6674C15.3296 11.5501 19.2881 -0.0154192 21.1244 1.54346e-05C22.9605 0.0155843 26.7402 11.6465 28.217 12.789C29.6938 13.9315 41.4231 14.2992 41.9765 16.1323C42.5298 17.9654 33.1324 25.3232 32.5508 27.1468C31.9693 28.9703 35.2599 40.763 33.7657 41.8804Z" fill="#F6F7F8"/>
          </g>
          <defs>
            <clipPath id="clip0_11263_36665">
              <rect width="42" height="42" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </ng-template>
    </p-rating>
  </div>
  <div class="">
    <div class="review-header">
      Отзыв
    </div>
    <div class="">
      <textarea [(ngModel)]="feedbackText" placeholder="Необязательно" class="review-description"></textarea>
    </div>
  </div>
  <div class="mt-3">
    <div class="review-header">
      Фото
    </div>
    <div class="drop-area"
         *ngIf="previewImages.length == 0"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)"
         (click)="fileInput.click()"
    >
      <div class="">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5.18311" width="26" height="26" rx="2" stroke="#0D87EF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.944 15.2943C14.1406 15.2943 15.1107 14.3242 15.1107 13.1276C15.1107 11.931 14.1406 10.9609 12.944 10.9609C11.7474 10.9609 10.7773 11.931 10.7773 13.1276C10.7773 14.3242 11.7474 15.2943 12.944 15.2943Z" stroke="#0D87EF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M31.0017 22.5167L23.7795 15.2944L7.89062 31.1833" stroke="#0D87EF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="">
        Можно загрузить до 5 изображений
      </div>
    </div>
    <input
      type="file"
      #fileInput
      (change)="onFileSelect($event)"
      multiple
      accept="image/*"
      hidden
    />
  </div>
  <div class="preview">
    <div *ngFor="let img of previewImages; let i = index" class="image-container">

      <img [src]="img" alt="Uploaded Image">

      <svg (click)="removeImage(i, $event)" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.75 8.74932L1.25068 1.25" stroke="#0D87EF" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.75 1.25L1.25068 8.74932" stroke="#0D87EF" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

    </div>
    <div *ngIf="previewImages.length > 0 && previewImages.length < 5" class="add-image"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)"
         (click)="fileInput.click()"
    >
      Добавить
    </div>
  </div>

  <div class="review-header flex align-items-center mb-2 mt-4">
    <div class="mr-auto">
      Анонимный отзыв
    </div>
    <p-inputSwitch [(ngModel)]="isAnonymous" />
  </div>
  <div class="review-header review-name">
    Вы оставляете отзыв как:
    <span *ngIf="!isAnonymous">
    {{ headerService?._userData?.userInfo?.firstName?.trim() ? headerService?._userData?.userInfo?.firstName : headerService?._userData?.userInfo?.email }}
    </span>
    <span *ngIf="isAnonymous">
      анонимный пользователь
    </span>
  </div>
  <div *ngIf="starErr" class="review-err-description">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.16797 4.83317H9.83464V6.49984H8.16797V4.83317ZM9.0013 13.1665C9.45964 13.1665 9.83464 12.7915 9.83464 12.3332V8.99984C9.83464 8.5415 9.45964 8.1665 9.0013 8.1665C8.54297 8.1665 8.16797 8.5415 8.16797 8.99984V12.3332C8.16797 12.7915 8.54297 13.1665 9.0013 13.1665ZM9.0013 0.666504C4.4013 0.666504 0.667969 4.39984 0.667969 8.99984C0.667969 13.5998 4.4013 17.3332 9.0013 17.3332C13.6013 17.3332 17.3346 13.5998 17.3346 8.99984C17.3346 4.39984 13.6013 0.666504 9.0013 0.666504ZM9.0013 15.6665C5.3263 15.6665 2.33464 12.6748 2.33464 8.99984C2.33464 5.32484 5.3263 2.33317 9.0013 2.33317C12.6763 2.33317 15.668 5.32484 15.668 8.99984C15.668 12.6748 12.6763 15.6665 9.0013 15.6665Z" fill="#D11635"/>
      </svg>
    <div class="">
      Для отправки отзыва нужно поставить оценку
    </div>
  </div>
  <div class="blue-btn-8-20 w-full text-center" (click)="sendReview()">
    Отправить отзыв
  </div>
</p-dialog>

<app-auth-dialog [url]="''" (successAuth)="getInfo()"></app-auth-dialog>
